/**
 * Container styles for the compact quoted-post card, shared by every surface
 * that must look like it (the Bluesky embed and the Tahquamenon ActivityPub
 * card) so the two cannot drift apart.
 */
export const QUOTED_POST_CARD_BASE_CLASS =
    'border border-border-light dark:border-border-dark rounded-lg overflow-hidden'

/** Hover/cursor treatment for a card that navigates somewhere when clicked. */
export const QUOTED_POST_CARD_INTERACTIVE_CLASS =
    'cursor-pointer hover:bg-surface-light/50 dark:hover:bg-surface-dark/50 transition-colors'

export const QUOTED_POST_CARD_CLASS = `${QUOTED_POST_CARD_BASE_CLASS} ${QUOTED_POST_CARD_INTERACTIVE_CLASS}`
